import axios from 'axios'
import { GET_TOKEN, REMOVE_TOKEN } from './auth'
import { Message } from 'element-ui'

const HTTP = axios.create({
  // baseURL: 'http://47.108.200.51:8080/',
  baseURL: 'https://tripitaka.bigbug.tech/',
  timeout: 20000
})

HTTP.interceptors.request.use(config => {
  const token = GET_TOKEN()
  if (token) {
    config.headers = {
      'token': token
    }
  }
  return config
})

HTTP.interceptors.response.use(
  response => {
    if (response.status === 200) {
      if (response.data) {
        const { data } = response
        if (data.code === 6007) {
          Message({
            type: 'warning',
            message: '请重新登录！',
            duration: 1000 * 3
          })
          REMOVE_TOKEN()
          setTimeout(() => {
            window.location.href = '/login'
          }, 1000)
        }
        if (data.code === 6404) {
          Message({
            type: 'error',
            message: '请求出错, 请稍后再试！',
            duration: 1000 * 3
          })
        }
      }
      return Promise.resolve(response.data)
    } else {
      return Promise.reject(response)
    }
  },
  error => {
    window.console.log(
      JSON.stringify(error.message)
    )
  }
)

export default HTTP
